var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBatchesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4183 14.8414C11.4385 14.8414 10.6442 15.6356 10.6442 16.6154C10.6442 17.5952 11.4385 18.3894 12.4183 18.3894H23.0625C24.0423 18.3894 24.8366 17.5952 24.8366 16.6154C24.8366 15.6356 24.0423 14.8414 23.0625 14.8414H12.4183Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.09617 21.9375C7.09617 20.9577 7.89044 20.1635 8.87021 20.1635H26.6106C27.5904 20.1635 28.3846 20.9577 28.3846 21.9375C28.3846 22.9173 27.5904 23.7116 26.6106 23.7116H8.87021C7.89044 23.7116 7.09617 22.9173 7.09617 21.9375Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5481 29.0337C3.5481 27.0741 5.13662 25.4856 7.09617 25.4856H28.3846C30.3442 25.4856 31.9327 27.0741 31.9327 29.0337V36.1298C31.9327 38.0894 30.3442 39.6779 28.3846 39.6779H7.09617C5.13662 39.6779 3.5481 38.0894 3.5481 36.1298V29.0337Z",
    fill: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9329 5.1923C22.9329 4.47539 23.514 3.89423 24.2309 3.89423H28.1252C28.8421 3.89423 29.4232 4.47539 29.4232 5.1923V9.08653C29.4232 9.80344 28.8421 10.3846 28.1252 10.3846H24.2309C23.514 10.3846 22.9329 9.80344 22.9329 9.08653V5.1923ZM25.529 7.78846V6.49038H26.8271V7.78846H25.529Z",
    fill: "#676869"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9329 16.875C22.9329 16.1581 23.514 15.5769 24.2309 15.5769H28.1252C28.8421 15.5769 29.4232 16.1581 29.4232 16.875V20.7692C29.4232 21.4861 28.8421 22.0673 28.1252 22.0673H24.2309C23.514 22.0673 22.9329 21.4861 22.9329 20.7692V16.875ZM25.529 19.4711V18.1731H26.8271V19.4711H25.529Z",
    fill: "#676869"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9136 3.89423C35.1967 3.89423 34.6156 4.47539 34.6156 5.1923V9.08653C34.6156 9.80344 35.1967 10.3846 35.9136 10.3846H39.8079C40.5248 10.3846 41.1059 9.80344 41.1059 9.08653V5.1923C41.1059 4.47539 40.5248 3.89423 39.8079 3.89423H35.9136ZM37.2117 6.49038V7.78846H38.5098V6.49038H37.2117Z",
    fill: "#676869"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3175 5.1923C33.3175 4.47539 32.7363 3.89423 32.0194 3.89423C31.3025 3.89423 30.7213 4.47539 30.7213 5.1923V6.49038C30.7213 7.20729 31.3025 7.78846 32.0194 7.78846C32.7363 7.78846 33.3175 7.20729 33.3175 6.49038V5.1923Z",
    fill: "#676869"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0194 9.08653C32.7363 9.08653 33.3175 9.6677 33.3175 10.3846V11.6827H35.9136C36.6305 11.6827 37.2117 12.2639 37.2117 12.9808C37.2117 13.6977 36.6305 14.2788 35.9136 14.2788H32.0194C31.3025 14.2788 30.7213 13.6977 30.7213 12.9808V10.3846C30.7213 9.6677 31.3025 9.08653 32.0194 9.08653Z",
    fill: "#676869"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8079 11.6827C39.091 11.6827 38.5098 12.2639 38.5098 12.9808C38.5098 13.6977 39.091 14.2788 39.8079 14.2788C40.5248 14.2788 41.1059 13.6977 41.1059 12.9808C41.1059 12.2639 40.5248 11.6827 39.8079 11.6827Z",
    fill: "#676869"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7213 16.875C30.7213 16.1581 31.3025 15.5769 32.0194 15.5769H33.3175C34.0344 15.5769 34.6156 16.1581 34.6156 16.875C34.6156 17.5919 34.0344 18.1731 33.3175 18.1731V20.7692C33.3175 21.4861 32.7363 22.0673 32.0194 22.0673C31.3025 22.0673 30.7213 21.4861 30.7213 20.7692V16.875Z",
    fill: "#676869"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1252 14.2788C28.8421 14.2788 29.4232 13.6977 29.4232 12.9808C29.4232 12.2639 28.8421 11.6827 28.1252 11.6827H24.2309C23.514 11.6827 22.9329 12.2639 22.9329 12.9808C22.9329 13.6977 23.514 14.2788 24.2309 14.2788H28.1252Z",
    fill: "#676869"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1059 16.875C41.1059 17.5919 40.5248 18.1731 39.8079 18.1731H37.2117C36.4948 18.1731 35.9136 17.5919 35.9136 16.875C35.9136 16.1581 36.4948 15.5769 37.2117 15.5769H39.8079C40.5248 15.5769 41.1059 16.1581 41.1059 16.875Z",
    fill: "#676869"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8079 22.0673C40.5248 22.0673 41.1059 21.4861 41.1059 20.7692C41.1059 20.0523 40.5248 19.4711 39.8079 19.4711H35.9136C35.1967 19.4711 34.6156 20.0523 34.6156 20.7692C34.6156 21.4861 35.1967 22.0673 35.9136 22.0673H39.8079Z",
    fill: "#676869"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchesIcon);
export default __webpack_public_path__ + "static/media/BatchesIcon.24c5e7ad.svg";
export { ForwardRef as ReactComponent };